import { render, staticRenderFns } from "./BCXMessengerChatGroup.vue?vue&type=template&id=19646a55&scoped=true"
import script from "./BCXMessengerChatGroup.vue?vue&type=script&lang=ts&setup=true"
export * from "./BCXMessengerChatGroup.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./BCXMessengerChatGroup.vue?vue&type=style&index=0&id=19646a55&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19646a55",
  null
  
)

export default component.exports